import { $authHost } from "../../http";
import { 
    DISEASE_GET_REQUEST, DISEASE_GET_SUCCESS, DISEASE_GET_ERROR, 
    DISEASE_GET_BY_KEY_REQUEST, DISEASE_GET_BY_KEY_SUCCESS, DISEASE_GET_BY_KEY_ERROR, 
    DISEASE_ADD_REQUEST, DISEASE_ADD_SUCCESS, DISEASE_ADD_ERROR, 
    DISEASE_EDIT_REQUEST, DISEASE_EDIT_SUCCESS, DISEASE_EDIT_ERROR, 
    DISEASE_DELETE_REQUEST, DISEASE_DELETE_SUCCESS, DISEASE_DELETE_ERROR
} from "../constants/diseaseConstants";

export const getDiseases = (args) => async (dispatch) => {
    try {
        dispatch({
            type: DISEASE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/disease/query",
            args || {},
            config,
        );
        dispatch({
            type: DISEASE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: DISEASE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getDiseaseByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: DISEASE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/disease/${id}`,
        );
        dispatch({
            type: DISEASE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: DISEASE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addDisease = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: DISEASE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/disease",
            { name, code, description },
            config,
        );
        dispatch(getDiseases(queryArgs || {}));
        dispatch({
            type: DISEASE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: DISEASE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editDisease = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: DISEASE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/disease",
            { id, name, code, description },
            config,
        );
        dispatch(getDiseases(queryArgs || {}));
        dispatch({
            type: DISEASE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: DISEASE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteDisease = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: DISEASE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/disease",
            { data: { id } },
            config,
        );
        dispatch(getDiseases(queryArgs || {}));
        dispatch({
            type: DISEASE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: DISEASE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

